import { useEffect, useState, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import BackgroundVideo from "../../common/BackgroundVideo";
import AtkTextField from "../../AtlaskitControls/AtkTextField";
import AtkLoader from "../../AtlaskitControls/AtkLoader";
import CommonValues from "../../common/utils";
import axios from "axios";
import MVRMiddleHeader from "./MVRMiddleHeader";
import MVRSidebar from "./MVRSidebar";
import AtkButton from "../../AtlaskitControls/AtkButton";
import { Toast } from "primereact/toast";
import MVRLandingPage from "./MVRLandingPage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import SectionMessage from "@atlaskit/section-message";
export default function MVRSelectionOptionsPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const toast: any = useRef("");
    const navigatedFromChatBot = location.state?.NAVIGATED_FROM_CHAT_BOT || false;
    const [clientName, setClientName] = useState("");
    const [insuredSearch, setInsuredSearch] = useState("");
    const [insuredClientId, setInsuredClientId] = useState("");
    const [insuredClientNameError, setInsuredClientNameError] = useState("");
    const [searchClientLoading, setSearchClientLoading] = useState(false);
    const [searchClientList, setSearchClientList] = useState<any>([]);
    const [showMVRLandingPage, setShowMVRLandingPage] = useState(false);
    const [clientNameErrorMessage, setClientNameErrorMessage] = useState("");
    const [showDriverList, setShowDriverList] = useState(false);
    const [driverList, setDriverList] = useState([]);
    const [driverDetails, setDriverDetails] = useState<any>([]);
    const [showDriverListLoading, setShowDriverListLoading] = useState(false);
    const [selectedDriverList, setSelectedDriverList] = useState<{ id: any; index: any; code: any; clientName: any }[]>([]);
    const [isUsingNewInformation, setIsUsingNewInformation] = useState(false);
    const [checkExistingDriver, setCheckExistingDriver] = useState(true);
    const [checkAddNewDriver, setCheckAddNewDriver] = useState(false);
    const [showRadioButtonOptions, setShowRadioButtonOptions] = useState(false);
    const hostname = window.location.hostname;
    useEffect(() => {
        if (hostname !== process.env.REACT_APP_Momentum_Url1 && hostname !== process.env.REACT_APP_Momentum_Url2 && hostname !== process.env.REACT_APP_Momentum_Url3 && hostname !== process.env.REACT_APP_Momentum_Url4) {
            navigate("/not-allowed");
        }
    }, [hostname, navigate]);
    useEffect(() => {
        const token = CommonValues.GetToken();
        if (token == "" || token == null) {
            CommonValues.Logout(navigate);
        }
    }, [])
    useEffect(() => {
        if (insuredSearch.replaceAll(" ", "") == "") {
            return;
        }
        setSearchClientLoading(true);
        if (CommonValues.GetTenantId() == process.env.REACT_APP_NowCerts_Tenant_Id) {
            const searchTimeout = setTimeout(() => {
                getNowCertsClients(insuredSearch);
            }, 10);
            return () => clearTimeout(searchTimeout);
        }
    }, [insuredSearch]);

    const getNowCertsClients = (query: string) => {
        setSearchClientList([]);
        var data = {
            SearchValue: query,
        };
        let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
        var config = {
            method: "GET",
            url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/customerlist?searchText=${query}&nowCertsToken=${nowCertsToken}`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then((response) => {
                if (response.data.length == 0) {
                    setSearchClientList([]);
                    setSearchClientLoading(false);
                } else {
                    setSearchClientList(response.data);
                    setSearchClientLoading(false);
                }
            })
            .catch((error) => {
                let errorMessage = "";
                if (error.response != null) {
                    if (error.response.status === 401) {
                        CommonValues.Logout(navigate);
                    } else {
                        if (toast.current) {
                            toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: "Unknown error while loading the insureds data.Please try again later",
                                life: 3000,
                            });
                        }
                    }
                }
                setSearchClientLoading(false);
            });
    };

    const getDriverList = (insuredId: string) => {
        setDriverList([]);
        setShowDriverListLoading(true);
        let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
        var config = {
            method: "GET",
            url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/driverlist?insuredId=${insuredId}&ncToken=${nowCertsToken}`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
                "Content-Type": "application/json",
            },
        };

        axios(config)
            .then((response) => {
                let driverDetailsList: any = [];
                setShowDriverListLoading(false);
                setShowDriverList(true);
                if (response.data.length > 0) {
                    response.data.map((item: any) => {
                        if (item.active == true) {
                            driverDetailsList.push(item)
                        }
                    })
                    setDriverList(driverDetailsList);
                }
                else {
                    setDriverList(response.data)
                }

            })
            .catch((error) => {
                let errorMessage = "";
                if (error.response != null) {
                    if (error.response.status === 401) {
                        CommonValues.Logout(navigate);
                    } else {
                        if (toast.current) {
                            toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: "Unknown error while get driver list.Please try again later",
                                life: 3000,
                            });
                        }
                    }
                }
                setShowDriverListLoading(false);
            });
    };

    const onClientSelectForInsured = (client: any) => {
        setInsuredSearch("");
        setClientName(client.name);
        setInsuredClientId(client.databaseId);
        setInsuredClientNameError("");
        getDriverList(client.databaseId);
        setShowRadioButtonOptions(true);
    };
    const onClientSearchChangeForInsured = (value: any) => {
        if (value.length > 255) {
            return;
        }
        setInsuredSearch(value);
        setClientNameErrorMessage("");
    };

    const onNextButtonClick = () => {
        if (checkValidation()) {
            setShowDriverList(false)
            setShowMVRLandingPage(true);
            setSelectedDriverList([])
            setShowRadioButtonOptions(false);
        }
    };

    const checkValidation = () => {
        let isValid = true;
        if (clientName == null || clientName == "") {
            isValid = false
            setClientNameErrorMessage("Please select client name.");
            return isValid
        }
        if (checkExistingDriver == true) {
            if (selectedDriverList.length == 0) {
                isValid = false
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: "Please select driver.",
                    life: 3000,
                });
                return isValid
            }
        }
        return isValid
    }

    const onBackButtonClick = () => {
        setShowMVRLandingPage(false);
        setShowDriverList(true);
        setDriverDetails([]);
        setInsuredSearch("");
        setShowDriverList(false);
        setIsUsingNewInformation(false);
        setClientName("");
        setInsuredSearch("");
        setCheckAddNewDriver(false);
        setCheckExistingDriver(true);
    };

    const handleRowSelect = (e: any) => {
        setSelectedDriverList(e.value);
    };

    const onSelectMultipleDriverList = (rowData: any, index: any) => {
        return (
            <div className="checkbox">
                <label>
                    <input
                        type="checkbox"
                        value=""
                        checked={Array.isArray(selectedDriverList) && selectedDriverList.some((item) => item.id === rowData.id)}
                        onChange={() => onSelectedMultipleDriverListChange(rowData, index)}
                        className="show-cursor bundle-checkbox"
                    />
                </label>
            </div>
        );
    };

    const onSelectedMultipleDriverListChange = (rowData: any, index: any) => {
        if (selectedDriverList.some((item) => item.id === rowData.id)) {
            // If the driver is already selected, unselect it
            setSelectedDriverList([]);
            setDriverDetails([]);
        } else {
            // Otherwise, select the driver
            setSelectedDriverList([
                {
                    id: rowData.id,
                    index: index,
                    code: rowData.code || "",
                    clientName: rowData.clientName,
                },
            ]);
            setDriverDetails(rowData);
        }
    };

    const handleExistingDriversChange = (e: any) => {
        if (e.target.checked) {
            setCheckExistingDriver(e.target.checked);
            setCheckAddNewDriver(false);
            setShowDriverList(true);
            setIsUsingNewInformation(false);
        } else {
            setCheckExistingDriver(e.target.checked);
            setCheckAddNewDriver(true);
        }
    }
    const handleAddNewDriverChange = (e: any) => {
        if (e.target.checked) {
            setCheckAddNewDriver(e.target.checked);
            setCheckExistingDriver(false);
            setIsUsingNewInformation(true);
            setShowDriverList(false);
            setDriverDetails([]);
            setSelectedDriverList([]);
        } else {
            setCheckAddNewDriver(e.target.checked);
            setIsUsingNewInformation(false);
        }
    }

    return (
        <><div className="mvr-main-page">
            <Toast ref={toast} />
            <Header pagename="mvr-landing-page" />
            <div className="content-wrapper">
                <BackgroundVideo />
                <div className="row  wrapper-main-row mx-auto wrapper-below-div">
                    <div className="col-12">
                        <MVRMiddleHeader />
                    </div>
                    <div className="row main-content-row mx-auto ">
                        <div className="col-lg-2 col-md-3 sidebar-col display-for-desktop">
                            <MVRSidebar pagename="mvr-landing-page" />
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 main-content-col ">
                            <div className="row  d-flex  align-items-end text-12 position-relative">
                                {showMVRLandingPage ? (
                                    <>
                                        <MVRLandingPage
                                            clientName={clientName}
                                            insuredClientId={insuredClientId}
                                            onBackButtonClick={onBackButtonClick}
                                            driverDetails={driverDetails}
                                            isUsingNewInformation={isUsingNewInformation}
                                        />
                                    </>
                                ) : (

                                    <div className="col-12  p-0">
                                        <div className="row mx-auto d-flex  align-items-center " style={{ backgroundColor: "#f6f6f6" }}>
                                            <div className="col-10">
                                                <div className="row scan-search-row mx-auto ">
                                                    <div className="col-3 position-relative mb-2 p-0">
                                                        <p className="text-16 fw-bold mb-1 ">Select Client
                                                            <span className="text-danger"> *</span>
                                                        </p>


                                                        <div className={`search-bar flex-column ${clientNameErrorMessage.length > 0 ? " validation-div " : " "}`}>
                                                            <AtkTextField
                                                                type="text"
                                                                id="client-name"
                                                                className={` ${clientName.length > 0 ? "clientname-placeholder" : ""} search-area w-100 `}
                                                                name="insuredSearch"
                                                                onChange={(e) => {
                                                                    onClientSearchChangeForInsured(e.target.value);
                                                                }}
                                                                value={insuredSearch}
                                                                placeholder={clientName.length > 0 ? clientName : "Enter client name"}
                                                            />

                                                        </div>
                                                        {insuredSearch.replaceAll(" ", "").length > 0 && (
                                                            <div id="client-search" className=" position-absolute  ">
                                                                {searchClientLoading ? (
                                                                    <div className="d-flex justify-content-center my-2 client-loader-div">
                                                                        <AtkLoader />
                                                                    </div>
                                                                ) : searchClientList.length == 0 ? (
                                                                    <div style={{ padding: "5px", background: "white" }}>
                                                                        <span style={{ color: "#ddd", marginLeft: "10px" }}>No results found</span>
                                                                    </div>
                                                                ) : (
                                                                    searchClientList.map((item: any) => (
                                                                        <div
                                                                            style={{ cursor: "pointer", width: "100%" }}
                                                                            onClick={() => {
                                                                                onClientSelectForInsured(item);
                                                                            }}
                                                                        >
                                                                            <a
                                                                                href="#"
                                                                                style={{
                                                                                    color: "black",
                                                                                    width: "100%",
                                                                                    fontSize: "12px",
                                                                                }}
                                                                            >
                                                                                {item.name}
                                                                            </a>
                                                                        </div>
                                                                    ))
                                                                )}
                                                            </div>
                                                        )}
                                                        <span className="text-danger text-12">{clientNameErrorMessage}</span>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="col-2 text-end ">
                                                <AtkButton label="Next" onClick={onNextButtonClick} className="pf-secondary-btn w-100 " />
                                            </div>
                                        </div>
                                    </div>

                                )}


                                {showDriverListLoading ? (
                                    <div className="d-flex justify-content-center my-2 client-loader-div">
                                        <AtkLoader />
                                    </div>
                                ) :
                                    <>
                                        <div className="row client-and-policy-title-row">
                                            <div className="col-12 d-flex align-items-center justify-content-between  mt-2 mb-2">
                                                <span className="d-flex align-items-center">
                                                    {showRadioButtonOptions ? <>
                                                        <div className="d-flex align-items-center">
                                                            <RadioButton
                                                                inputId="existingDrivers"
                                                                name="existingDrivers"
                                                                value="existingDrivers"
                                                                onChange={(e) => handleExistingDriversChange(e)}
                                                                checked={checkExistingDriver}
                                                            />
                                                            <label htmlFor="existingDrivers" className="mx-2">
                                                                <b>Existing Driver</b>
                                                            </label>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <RadioButton
                                                                inputId="addNewDriver"
                                                                name="addNewDriver"
                                                                value="addNewDriver"
                                                                onChange={(e) => handleAddNewDriverChange(e)}
                                                                checked={checkAddNewDriver}
                                                            />
                                                            <label htmlFor="addNewDriver" className="mx-2">
                                                                <b>New Driver</b>
                                                            </label>
                                                        </div>
                                                    </> : null}
                                                </span>
                                            </div>
                                            <div className="">
                                                {showDriverList ? (
                                                    <>
                                                        <span className=" d-flex align-items-center policy-type-heading me-2 mt-2">Existing Drivers List</span>
                                                        <div className="row p-2 mx-auto history-table">
                                                            <DataTable
                                                                value={driverList.sort((a: any, b: any) => new Date(b.createDate).getTime() - new Date(a.createDate).getTime())}
                                                                paginator
                                                                paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                                                                rows={10}
                                                                selectionMode="single"
                                                                onSelectionChange={(e) => {
                                                                    handleRowSelect({ value: [e.value] });
                                                                }}
                                                                emptyMessage="No data available."
                                                            >
                                                                <Column
                                                                    header="Select"
                                                                    field=""
                                                                    body={(rowData, rowIndex) => onSelectMultipleDriverList(rowData, rowIndex)}
                                                                    bodyClassName="hide-cursor"
                                                                ></Column>
                                                                <Column
                                                                    header="First Name"
                                                                    field="firstName"
                                                                    bodyClassName="hide-cursor"
                                                                    sortable
                                                                ></Column>
                                                                <Column
                                                                    header="Middle Name"
                                                                    field="middleName"
                                                                    bodyClassName="hide-cursor"
                                                                    sortable
                                                                ></Column>
                                                                <Column
                                                                    header="Last Name"
                                                                    field="lastName"
                                                                    bodyClassName="hide-cursor"
                                                                    sortable
                                                                ></Column>
                                                                <Column
                                                                    header="License Number"
                                                                    field="licenseNumber"
                                                                    bodyClassName="hide-cursor"
                                                                    sortable
                                                                ></Column>
                                                            </DataTable>
                                                        </div>
                                                    </>
                                                ) : <>
                                                    {showRadioButtonOptions && checkAddNewDriver ?
                                                        <div className="row p-2  no-client-msg">
                                                            <div className="col-12 text-center ">
                                                                <h6> Click on Next button to continue.</h6>{" "}
                                                            </div>
                                                        </div>
                                                        : null}
                                                </>}
                                            </div>
                                        </div>
                                    </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}